<template>
	<div class="w" @click="onToggleClick">
		<el-icon size="1rem">
			<Plus v-if="!isExpand" />
			<Minus v-else />
		</el-icon>
	</div>
</template>

<script lang="ts">
import { ElIcon } from 'element-plus';
import { Options, Vue } from 'vue-class-component';
import { Plus, Minus } from '@element-plus/icons-vue';

@Options({
	props: {
		modelValue: {
			type: Boolean,
			default: false
		}
	},
	components: {
		ElIcon,
		Plus, Minus
	},
	emits: ['update:modelValue'],
})
export default class ExpandButtonComponent extends Vue {
	/** props */
	modelValue!: boolean;

	/** view-models */
	isExpand = false;

	mounted() {
		this.isExpand = this.modelValue === true;
	}

	onToggleClick() {
		this.isExpand = !this.isExpand;
		this.$emit('update:modelValue', this.isExpand);
	}
}
</script>

<style scoped>
.w {
	cursor: pointer;
	border-width: 1px;
	border-style: solid;	
	display: inline-block;
	line-height: 1rem;
	padding: .12rem .12rem 0 .12rem;
	color: var(--el-color-primary);
	border-color: var(--el-color-primary-light-5);
	background-color: var(--el-color-primary-light-8);
	border-radius: 2px;

	transition:
		border-color ease-in-out .2s, 
		background-color ease-in-out .2s;
}

	.w:hover {
		border-color: var(--el-color-primary-light-3);
		background-color: var(--el-color-primary-light-7);
	}
</style>